import React, { useState, useEffect } from 'react';
import getNotifications from '../api/getNotifications';
import { formatDate } from '@/utils/format';

type Notification = {
  position: number;
  startAt: string;
  body: string;
}

type Notifications = Notification[];

type NotificationListProps = {
  path: string;
};

const NotificationList: React.FC<NotificationListProps> = ({ path }) => {
  const [notificationList, setNotificationList] = useState<Notifications | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getNotifications({ path });
        setNotificationList(response.data);
      } catch (error) {
        console.error("An error occurred while fetching the notifications:", error);
      }
    };

    fetchData();
  }, [path]);
  
  return (
    <React.Fragment>
        <section className="sec-posts">
        <div className="inner">
          <div className="posts-box">
            <h1 className="posts-box__heading">シードからのご案内</h1>
              <ul className="posts-box__list">
                {
                  notificationList &&  notificationList.length > 0 ? (
                    notificationList.map((notification, index) => (
                    <li key={index} className="posts-box__list-item">
                      <div>
                        <span>{formatDate(notification.startAt)}</span>
                        <p>{notification.body}</p>
                      </div>
                    </li>
                    ))
                  ) : (
                    <li className="posts-box__list-item">
                      <div>
                        <p>お知らせはありません。</p>
                      </div>
                    </li>
                  )
                }
              </ul>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default NotificationList;